export const stateOfSalesV2Colors = {
  anchor: "#231942",
  positive: "#1D819A",
  negative: "#9F3A4A",
  neutral: "#9CA3AF",
} as const;

export const stateOfSalesV2L1Layout = {
  compositionBand: "lg:h-[88px]",
  positionBand: "lg:h-[136px]",
  visualHeader: "flex min-h-7 items-center justify-between gap-3",
} as const;

export const stateOfSalesV2LegendClassName =
  "flex flex-wrap items-center gap-x-4 gap-y-1 text-[11px] text-gray-500";
export const stateOfSalesV2LegendSwatchClassName = "h-2 w-3 rounded-sm";
